/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChainSearchResponse
 */
export interface ChainSearchResponse {
    /**
     * 
     * @type {string}
     * @memberof ChainSearchResponse
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof ChainSearchResponse
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ChainSearchResponse
     */
    result: string;
}

export function ChainSearchResponseFromJSON(json: any): ChainSearchResponse {
    return ChainSearchResponseFromJSONTyped(json, false);
}

export function ChainSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChainSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': json['key'],
        'type': json['type'],
        'result': json['result'],
    };
}

export function ChainSearchResponseToJSON(value?: ChainSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'type': value.type,
        'result': value.result,
    };
}


